import { ErrorName } from './ErrorName';

export class PageParamsDecodeError extends Error {
    public readonly name = ErrorName.PageParamsDecodeError;

    public constructor(message?: string) {
        super(message);
    }
}
